import { render, staticRenderFns } from "./mac-MT4.vue?vue&type=template&id=47aba3be&scoped=true&"
import script from "./mac-MT4.vue?vue&type=script&lang=js&"
export * from "./mac-MT4.vue?vue&type=script&lang=js&"
import style0 from "./mac-MT4.vue?vue&type=style&index=0&id=47aba3be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aba3be",
  null
  
)

export default component.exports